import React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

interface IUserLinkProps {
    username: string;
}

const StyledUsername = styled(Link)(({ theme }) => ({
    fontWeight: 500,
    color: theme.palette.text.primary,
    textDecoration: "none",
    transition: "color 0.2s ease",
    "&:hover": {
        color: theme.palette.primary.main,
        textDecoration: "underline",
        cursor: "pointer",
    },
}));

const UserLink: React.FC<IUserLinkProps> = ({ username }) => {
    const href = "/profile/" + username;

    return (
        <Typography variant="body1" component="span">
            <StyledUsername href={href}>{username}</StyledUsername>
        </Typography>
    );
};

export default UserLink;
